import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, Mic, GraduationCap, FlaskConical, Megaphone } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/motion";

const ICONS = [Mic, GraduationCap, FlaskConical, Megaphone];

export default function Professionals() {
  const { t } = useTranslation();
  const ways = t("professionals.ways", { returnObjects: true });

  return (
    <div data-testid="page-professionals">
      <PageHero testId="prof-hero" kicker={t("professionals.kicker")} title={t("professionals.headline")} lead={t("professionals.lead")} />

      <section className="surface-2" data-testid="prof-ways">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-20 lg:py-28">
          <Reveal>
            <h2 className="font-display text-4xl lg:text-6xl text-ink max-w-3xl leading-[1.02]">{t("professionals.ways_title")}</h2>
          </Reveal>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
            {Array.isArray(ways) && ways.map((w, i) => {
              const Icon = ICONS[i] || Mic;
              return (
                <Reveal key={i} delay={i * 0.08}>
                  <div className="group gxr-card p-10 h-full" data-testid={`prof-way-${i}`}>
                    <div className="flex items-start justify-between">
                      <span className="icon-tile"><Icon className="h-5 w-5" /></span>
                      <div className="font-display text-5xl text-gold/40">0{i + 1}</div>
                    </div>
                    <h3 className="font-display text-2xl lg:text-3xl mt-8 leading-tight text-ink">{w.t}</h3>
                    <p className="mt-4 text-slate leading-relaxed">{w.b}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="panel-forest" data-testid="prof-cta">
        <div className="relative max-w-[1500px] mx-auto px-6 lg:px-12 py-20 lg:py-24 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <p className="font-display text-3xl lg:text-5xl max-w-3xl text-white leading-tight">{t("professionals.cta")}.</p>
          <Link to="/contact" data-testid="prof-cta-btn" className="btn-gold">
            {t("professionals.cta")} <ArrowRight className="h-4 w-4 rtl:rotate-180" />
          </Link>
        </div>
      </section>
    </div>
  );
}
